import { ReactNode, FC } from "react";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import * as Color from "../Color";
import styled from "styled-components";
import { Handle } from "./Handle";
import { ItemContent } from "./ItemContent";
import { Icon } from "../Icon";

/** The `ListItemOverlay` component properties. */
interface ListItemOverlayProps {

  /** The item children. */
  readonly children?: ReactNode;
}

const StyledDiv = styled.div`
  box-sizing: border-box;
  background-color: ${Color.toString(Color.White)};
  border: solid 1px ${Color.toString(Color.Turqoise[300])};
  padding: 0.5rem;
  border-radius: 0.25rem;
  margin: 0;
  pointer-events: none;
  box-shadow: 0 0.25rem 1rem ${Color.toString(Color.withAlpha(Color.Black, 0.08))};
`;

/** An individual draggable item within the orderable list. */
export const ListItemOverlay: FC<ListItemOverlayProps> = (props) => {
  const { children } = props;

  return (
    <StyledDiv>
      <Shelf spacing="small">
        <Handle className="active"><Icon name="grabber" size="regular" color={Color.LightGrey[500]} /></Handle>
        <ItemContent>
          {children}
        </ItemContent>
      </Shelf>
    </StyledDiv>
  );
};
